import React from "react";
import { Fade } from "react-reveal";
import scr1 from "../../images/Svg/homepage/review/SCR-1.svg";
import scr2 from "../../images/Svg/homepage/review/SCR-2.svg";
import scr3 from "../../images/Svg/homepage/review/SCR-3.svg";
import scr4 from "../../images/Svg/homepage/review/SCR-4.svg";
import scr5 from "../../images/Svg/homepage/review/SCR-5.svg";
import scr6 from "../../images/Svg/homepage/review/SCR-6.svg";
import scr7 from "../../images/Svg/homepage/review/SCR-7.svg";
import scr8 from "../../images/Svg/homepage/review/SCR-8.svg";
import scr9 from "../../images/Svg/homepage/review/SCR-9.svg";
import CountUp from "react-countup";

import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Pagination, Autoplay } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { useState } from "react";

const Count = () => {
  const data = [
    {
      number: "20",
      text: "Users",
    },
    {
      number: "500",
      text: "Tweets moved",
    },
    {
      number: "5000",
      text: "Subscribers",
    },
  ];

  const reviewImages = [
    {
      id: 1,
      image: scr1,
      image2: scr4,
      image3: scr7,
    },
    {
      id: 2,
      image: scr2,
      image2: scr5,
      image3: scr8,
    },
    {
      id: 3,
      image: scr3,
      image2: scr6,
      image3: scr9,
    },
  ];
  return (
    <Fade cascade duration={1000}>
      <section className="bg-[#F6F2FF] relative">
        <div className={`container mx-auto py-4 mt-[250px]`}>
          <div className="container mx-auto z-[1002] absolute -top-[2.5%] lg:-top-[12%] bg-[#fff] box_shadow">
            <div className="grid grid-cols-3">
              {data.map((data, index) => (
                <div
                  className=" text-justify md:mb-[16px] py-[24px] flex items-center justify-center"
                  key={index}
                >
                  <div className="px-[8px]">
                    <h3 className="text-[24px] lg:text-[64px] text-blue font-bold leading-[24px] lg:leading-[74.8px]">
                      <CountUp duration={2} end={data.number} />
                      {index !== 2 && <span>K</span>}
                      <span>+</span>
                    </h3>
                    <p className="text-[#000000] text-[13px] lg:text-[24px] font-[600] text-center">
                      {data.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="container mx-auto mt-[80px] md:mt-[100px]">
            <div className="lg:grid lg:grid-cols-3 hidden">
              {reviewImages.map((data, index) => (
                <div className={`${data?.id !== 3 ? "lg:mr-[24px]" : ""}`}>
                  <img className="my-[24px] w-[98%]" src={data.image} alt="" />
                  <img className="my-[24px] w-[98%]" src={data.image2} alt="" />
                  <img className="my-[24px] w-[98%]" src={data.image3} alt="" />
                </div>
              ))}
            </div>
            <div className="lg:hidden">
              <Swiper
                direction="horizontal"
                loop={true}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: true,
                }}
                modules={[Pagination, Autoplay]}
                className="mySwiper"
                mousewheel={true}
              >
                {reviewImages.map((data, index) => (
                  <SwiperSlide key={index}>
                    <div className={`${data?.id !== 3 ? "lg:mr-[24px]" : ""}`}>
                      <img
                        className="my-[24px] w-[95%] mx-auto"
                        src={data.image}
                        alt=""
                      />
                      <img
                        className="my-[24px] w-[95%] mx-auto"
                        src={data.image2}
                        alt=""
                      />
                      <img
                        className="my-[24px] w-[95%] mx-auto"
                        src={data.image3}
                        alt=""
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </Fade>
  );
};

export default Count;
